import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";

// Aviso que reemplaza el input cuando la ventana de servicio de 24h (WABA) está
// cerrada: el texto libre no está permitido, solo se puede iniciar con una plantilla
// aprobada por Meta. Doc 0367 (H8).
const useStyles = makeStyles((theme) => ({
  "@keyframes pulseGreen": {
    "0%": { boxShadow: "0 0 0 0 rgba(37,211,102,0.55)" },
    "70%": { boxShadow: "0 0 0 12px rgba(37,211,102,0)" },
    "100%": { boxShadow: "0 0 0 0 rgba(37,211,102,0)" },
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    flexWrap: "wrap",
  },
  iconBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40,
    borderRadius: "50%",
    flexShrink: 0,
  },
  texts: { flex: 1, minWidth: 200 },
  title: { fontWeight: 600, fontSize: "0.9rem" },
  subtitle: { fontSize: "0.8rem" },
  pulseButton: {
    animation: "$pulseGreen 2s infinite",
    backgroundColor: "#25d366",
    color: "#fff",
    fontWeight: 600,
    whiteSpace: "nowrap",
    "&:hover": { backgroundColor: "#1eb457" },
  },
}));

export default function ServiceWindowNotice({ onOpenTemplates }) {
  const classes = useStyles();
  const theme = useTheme();
  const isDark = theme.mode === "dark";

  return (
    <Paper square elevation={0} className={classes.wrapper}>
      <div
        className={classes.iconBox}
        style={{ backgroundColor: isDark ? "#4a3b12" : "#fff3cd" }}
      >
        <AccessTimeIcon style={{ color: isDark ? "#fbbf24" : "#856404" }} />
      </div>

      <div className={classes.texts}>
        <Typography
          className={classes.title}
          style={{ color: isDark ? "#fbbf24" : "#856404" }}
        >
          Ventana de 24 h cerrada
        </Typography>
        <Typography
          className={classes.subtitle}
          style={{ color: isDark ? "#d1d5db" : "#6b6b6b" }}
        >
          El cliente no ha escrito en las últimas 24 h. Para reabrir la conversación
          debes enviar una plantilla aprobada por Meta.
        </Typography>
      </div>

      <Button
        variant="contained"
        className={classes.pulseButton}
        startIcon={<DescriptionOutlinedIcon />}
        onClick={onOpenTemplates}
      >
        Enviar plantilla
      </Button>
    </Paper>
  );
}
